import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '@/api';

/**
 * Owner-only: approve a pending join request. The server upgrades the request
 * row to "approved" AND adds the user to the group atomically. We invalidate
 * both the pending-requests list and the members list so the UI updates in
 * one cycle.
 */
export function useApproveJoinRequest(groupId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (requestId: string) =>
      api.post<{ ok: true }>(
        `/api/groups/${groupId}/join-requests/${requestId}/approve`,
      ),
    onSuccess: () => {
      void qc.invalidateQueries({
        queryKey: ['groups', 'join-requests', groupId],
      });
      void qc.invalidateQueries({ queryKey: ['groups', 'members', groupId] });
      void qc.invalidateQueries({ queryKey: ['groups', 'my'] });
      void qc.invalidateQueries({ queryKey: ['standings'] });
    },
  });
}
